import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import MediumshipLogo from '../components/MediumshipLogo';
import GoogleSignInButton from '../components/GoogleSignInButton';
import './Auth.css';

function Register({ onRegister, apiUrl }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleAuth = (userData) => {
    onRegister(userData);
    navigate('/');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!acceptedTerms) {
      setError('You must agree to the Terms & Conditions and Privacy Policy');
      return;
    }
    setLoading(true);

    try {
      const response = await axios.post(`${apiUrl}/auth/register`, { ...formData, accepted_terms: acceptedTerms });
      handleAuth({ token: response.data.token, user: response.data.user });
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <MediumshipLogo variant="stacked" size={40} style={{ margin: '0 auto 20px', justifyContent: 'center' }} />
        <h1>Register</h1>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Phone:</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <label className="auth-checkbox">
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <span>
              I agree to the <a href="/legal/terms" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a> and{' '}
              <a href="/legal/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </span>
          </label>
          <button type="submit" className="btn-auth" disabled={loading || !acceptedTerms}>
            {loading ? 'Registering...' : 'Register'}
          </button>
        </form>
        <div className="auth-divider">or</div>
        <GoogleSignInButton apiUrl={apiUrl} onAuth={handleAuth} onError={setError} acceptedTerms={acceptedTerms} />
        <p>Already have an account? <a href="/login">Login here</a></p>
      </div>
    </div>
  );
}

export default Register;
